<template>
  <div class="small-12 columns my-5 custom-field">
    <div class="small-5 columns">
      <input v-model="key" type="text" placeholder="Enter key eg: skills" />
    </div>
    <div class="small-5 columns">
      <input
        v-model="value"
        type="text"
        placeholder="Enter value eg: python, javascript"
      />
    </div>
    <button v-if="inputKey" class="btn btn-red" @click.prevent="removeField">
      remove
    </button>
    <button
      v-else-if="key && value"
      class="btn btn-green"
      @click.prevent="addField"
    >
      add
    </button>
  </div>
</template>

<script>
export default {
  props: ["inputIndex", "inputKey", "inputValue"],
  data() {
    return {
      key: "",
      value: "",
    }
  },
  watch: {
    inputKey() {
      this.key = this.inputKey
    },
    inputValue() {
      this.value = this.inputValue
    },
  },
  mounted() {
    this.key = this.inputKey ? this.inputKey : ""
    this.value = this.inputValue ? this.inputValue : ""
  },
  methods: {
    addField() {
      this.$emit("FIELD_ADDED", this.key, this.value)
      this.key = ""
      this.value = ""
    },
    removeField() {
      this.$emit("FIELD_REMOVED", this.key)
    },
  },
}
</script>

<style scoped>
.btn {
  width: 100px;
  height: auto;
  margin: auto;
  padding: 5px;
  border-radius: 10px;
  color: white;
  background-color: #39be70;
  box-shadow: 0 2px 3px 0 #575757;
  text-shadow: none;
  font-weight: 500;
}

.custom-field >>> input {
  height: 34px;
  padding-left: 8px;
  border-radius: 4px;
}
</style>
